import { useState } from 'react';
import { fetchNotaHtml } from './services/noteApi';
import { downloadAsHtml5 } from './utils/downloadFile';
import { SearchForm } from './components/SearchForm';
import { NotePreview } from './components/NotePreview';

function App() {
  const [currentQuery, setCurrentQuery] = useState('');
  const [htmlContent, setHtmlContent] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSearch = async (query) => {
    setIsLoading(true);
    setError(null);
    setHtmlContent('');
    setCurrentQuery(query);

    try {
      const data = await fetchNotaHtml(query);
      setHtmlContent(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownload = () => {
    downloadAsHtml5(htmlContent, currentQuery);
  };

  return (
    // Fondo gris institucional
    <div className="min-h-screen bg-idc-gray py-12 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-5xl mx-auto space-y-10">
        
        {/* Cabecera */}
        <div className="text-center">
          <h1 className="text-3xl font-black text-idc-dark tracking-tight uppercase">
            Portal de <span className="text-idc-red">Consulta</span>
          </h1>
          <p className="mt-3 text-base text-gray-500 font-medium max-w-2xl mx-auto">
            Ingrese el título o criterio de búsqueda para localizar la nota fiscal, legal o laboral.
          </p>
        </div>

        {/* Buscador */}
        <SearchForm onSearch={handleSearch} isLoading={isLoading} />

        {/* Alerta de Error (si ocurre) */}
        {error && (
          <div className="max-w-4xl mx-auto p-4 bg-red-50 border-l-4 border-idc-red">
            <p className="text-idc-darkred font-medium text-sm">{error}</p>
          </div>
        )}

        {/* Componente de Vista Previa */}
        <NotePreview 
          htmlContent={htmlContent} 
          onDownload={handleDownload} 
        />
        
      </div>
    </div>
  );
}

export default App;